import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspotSyncLogs = {
  index: async(props) => {
    const { default: SyncLogsIndex } = await import('@/vue_widgets/admin/hubspot/sync_logs/index.vue')
    createVueApp(SyncLogsIndex, { props, sidebar })
  }
}
